export const convertDateFormat = (subscriptionDate : string | undefined) : string => {
    if(typeof subscriptionDate  == 'string'){
        const date = new Date(subscriptionDate)
        const month = date.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : month;
        const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
        const year = date.getFullYear()
        return ` ${formattedMonth}/${day}/${year}`
    }
    else if(subscriptionDate === null){
        return 'Unavailable'
    }
    else{
        return ''
    }
}

export const getSubscriptionLength = (productId : string | undefined) : string => {
    if(typeof productId  == 'string'){
        const subscriptionLength  = productId.split(':').pop() as string
        if(Number(subscriptionLength[0]) > 1){
            return `${subscriptionLength[0]} Months`
        }
        else{
            return `${subscriptionLength[0]} Month`
        }
    }
    return ''
}
